(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbd-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class NBDCarousel extends HTMLElement {
      constructor() {
        super();
        this.slides = [...this.querySelectorAll('.nbd-carousel__slide')];
        if (this.slides.length < 2) return;

        window.NBD.intersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              observer.unobserve(entry.target);
            }
          });
        }, this, { rootMargin: '0px 0px 500px 0px' });
      }

      init() {
        if (this.hasAttribute('loaded')) return;

        this.slider = this.querySelector('.nbd-carousel__slider');
        this.grid = this.querySelector('.nbd-carousel__grid');
        this.nav = this.querySelector('.nbd-carousel__nav');
        this.rtl = document.dir === 'rtl';

        if (this.nav) {
          this.prevBtn = this.querySelector('button[name="prev"]');
          this.nextBtn = this.querySelector('button[name="next"]');
        }

        this.initSlider();
        this.setAttribute('loaded', '');
      }

      initSlider() {
        this.gridWidth = this.grid.clientWidth;
        this.slideSpan = this.getWindowOffset(this.slides[1]) - this.getWindowOffset(this.slides[0]);
        this.sliderStart = this.getWindowOffset(this.slider);
        if (!this.sliderStart) this.sliderStart = (this.slider.clientWidth - this.gridWidth) / 2;
        this.sliderEnd = this.sliderStart + this.gridWidth;

        this.addListeners();

        if (window.matchMedia('(pointer: fine)').matches) {
          this.slider.classList.add('is-grabbable');
        }

        if (this.nav) {
          this.setButtonStates();
        }
      }

      refresh() {
        if (this.hasAttribute('loaded')) {
          this.removeAttribute('loaded');
          this.removeListeners();
        }
        this.slides = [...this.querySelectorAll('.nbd-carousel__slide')];
        if (this.slides.length < 2) return;
        this.init();
      }

      addListeners() {
        this.scrollHandler = window.NBD.debounce(this.handleScroll.bind(this), 100);
        this.slider.addEventListener('scroll', this.scrollHandler);

        if (this.nav) {
          this.navClickHandler = this.handleNavClick.bind(this);
          this.nav.addEventListener('click', this.navClickHandler);
        }

        if (window.matchMedia('(pointer: fine)').matches) {
          this.mousedownHandler = this.handleMousedown.bind(this);
          this.mouseupHandler = this.handleMouseup.bind(this);
          this.mousemoveHandler = this.handleMousemove.bind(this);

          this.slider.addEventListener('mousedown', this.mousedownHandler);
          this.slider.addEventListener('mouseup', this.mouseupHandler);
          this.slider.addEventListener('mouseleave', this.mouseupHandler);
          this.slider.addEventListener('mousemove', this.mousemoveHandler);
          this.slider.addEventListener('dragstart', (evt) => { evt.preventDefault(); });
        }

        this.resizeHandler = window.NBD.debounce(this.refresh.bind(this));
        window.addEventListener('resize', this.resizeHandler);
      }

      removeListeners() {
        this.slider.removeEventListener('scroll', this.scrollHandler);

        if (this.nav) {
          this.nav.removeEventListener('click', this.navClickHandler);
        }

        if (window.matchMedia('(pointer: fine)').matches) {
          this.slider.removeEventListener('mousedown', this.mousedownHandler);
          this.slider.removeEventListener('mouseup', this.mouseupHandler);
          this.slider.removeEventListener('mouseleave', this.mouseupHandler);
          this.slider.removeEventListener('mousemove', this.mousemoveHandler);
        }

        window.removeEventListener('resize', this.resizeHandler);
      }

      handleMousedown(evt) {
        this.mousedown = true;
        this.mousemoved = false;
        this.startX = evt.pageX - this.sliderStart;
        this.scrollPos = this.slider.scrollLeft;
        this.slider.classList.add('is-grabbing');
      }

      handleMouseup(evt) {
        this.mousedown = false;
        this.slider.classList.remove('is-grabbing');
        if (this.mousemoved) {
          evt.preventDefault();
          this.slider.classList.remove('is-dragging');
        }
      }

      handleMousemove(evt) {
        if (!this.mousedown) return;
        evt.preventDefault();

        const x = evt.pageX - this.sliderStart;
        this.slider.scrollTo({ left: this.scrollPos - (x - this.startX), behavior: 'instant' });
        if (Math.abs(x - this.startX) > 8) {
          this.mousemoved = true;
          this.slider.classList.add('is-dragging');
        }
      }

      handleScroll() {
        if (this.gridWidth !== this.grid.clientWidth) this.refresh();
        this.currentIndex = Math.round(Math.abs(this.slider.scrollLeft) / this.slideSpan);
        if (this.nav) this.setButtonStates();
      }

      handleNavClick(evt) {
        const btn = evt.target.closest('button');
        if (!btn) return;

        if ((btn.name === 'next' && !this.rtl) || (btn.name === 'prev' && this.rtl)) {
          this.scrollPos = this.slider.scrollLeft + this.slideSpan;
        } else {
          this.scrollPos = this.slider.scrollLeft - this.slideSpan;
        }

        this.slider.scrollTo({ left: this.scrollPos, behavior: 'smooth' });
      }

      getWindowOffset(el) {
        return this.rtl
          ? window.innerWidth - el.getBoundingClientRect().right
          : el.getBoundingClientRect().left;
      }

      getSlideVisibility(el) {
        const slideStart = this.getWindowOffset(el);
        const slideEnd = Math.floor(slideStart + this.slides[0].clientWidth);
        return slideStart >= this.sliderStart && slideEnd <= this.sliderEnd;
      }

      setButtonStates() {
        this.prevBtn.disabled = this.getSlideVisibility(this.slides[0]) && this.slider.scrollLeft === 0;
        this.nextBtn.disabled = this.getSlideVisibility(this.slides[this.slides.length - 1]);
      }
    }

    customElements.define('nbd-carousel', NBDCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbd-custom-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  class NBDCartUpsell extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
      this.target = this.querySelector('.nbd-cart-upsell-products');
      document.addEventListener('on:cart-drawer:after-open', () => {
        this.handleCartOpen();
      });
      document.addEventListener('on:cart-drawer:before-close', () => {
        this.handleCartClose();
      });
    }

    connectedCallback() {
      this.refreshData();

      document.addEventListener('on:cart:after-merge', async () => {
        this.cart = await this.fetchCart();
        if (this.cart.item_count < 1) {
          this.handleCartClose();
        } else {
          this.refreshData();
        }
      });
    }

    async fetchCart() {
      let res = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      let cart = await res.json();
      return cart;
    }

    async addToCart(variantId) {
      try {
        let res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
        if (!res.ok) throw new Error('Network response was not ok');
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        return true;
      } catch (error) {
        console.error('Error adding item to cart:', error);
        return false;
      }
    }

    registerAddToCartButtons() {
      const buttons = this.querySelectorAll('button[data-variant-id]');
      buttons.forEach((button) => {
        button.addEventListener('click', async (event) => {
          const button = event.currentTarget;
          if (button.getAttribute('data-loading')) return;
          const variantId = button.getAttribute('data-variant-id');
          const defaultText = button.innerText;
          button.disabled = true;
          button.setAttribute('data-result', '');
          button.setAttribute('data-loading', '');
          button.innerText = 'Adding...';
          let success = await this.addToCart(variantId);
          if (!success) {
            button.setAttribute('data-result', 'error');
            button.innerText = 'Problem adding to cart';
          } else {
            button.innerText = defaultText;
            button.setAttribute('data-result', 'success');
            button.disabled = false;
          }
          button.setAttribute('data-loading', false);
        });
      });
    }

    async recommendationsUrl() {
      let url = new URL(this.dataset.from, window.location.origin);
      if (!url.searchParams.get('product_id') || url.searchParams.get('product_id') === '') {
        let cart = await this.fetchCart();
        if (cart.item_count > 0) {
          url.searchParams.set('product_id', cart.items[0].product_id);
        } else {
          this.handleCartClose();
        }
      }
      return url;
    }

    async refreshData() {
      try {
        let url = await this.recommendationsUrl();
        let res = await fetch(url);
        let html = await res.text();
        this.target.innerHTML = html;
        this.registerAddToCartButtons();
      } catch (error) {
        console.error('Error fetching cart upsell products:', error);
      }
    }

    async handleCartOpen() {
      let cart = await this.fetchCart();
      if (cart.item_count > 0) {
        this.setAttribute('data-cart-open', 'true');
      }
    }

    handleCartClose() {
      this.setAttribute('data-cart-open', 'false');
    }
  }

  customElements.define('nbd-cart-upsell', NBDCartUpsell);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbd-load-more"] && !Shopify.designMode) return;
  try {
    
  class NBDLoadMore extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.page = 1;
      this.insertSelector = this.getAttribute('insert-selector');
      this.itemSelector = this.getAttribute('item-selector');
      this.paginationSelector = this.getAttribute('pagination-selector');
      this.button = this.querySelector('button');
      this.counter = this.querySelector('.counter');
    }

    connectedCallback() {
      this.button.addEventListener('click', () => this.loadMore());
      this.handleFilters();
      this.refresh();
    }

    handleFilters() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mu) => {
          if (mu.type !== 'attributes' && mu.attributeName !== 'class') return;
          if (mu.target.classList.contains('ajax-loading')) {
            this.loading();
            return;
          }
          this.refresh();
        });
      });

      const observables = document.querySelectorAll('.utility-bar[data-ajax-container]');
      observables.forEach((el) => observer.observe(el, { attributes: true }));
    }

    handleImages() {
      theme?.ProductBlockManager?.loadImages(this.container);
    }

    loading() {
      this.button.disabled = true;
      this.style.opacity = 0;
    }

    complete() {
      if (this.items.length < 1) {
        this.counter.innerText = '';
        this.button.style.display = 'none';
        return;
      }
      this.button.disabled = false;
      this.button.style.display = 'inherit';
      this.style.opacity = 1;
      this.counter.innerText = `Show next ${this.items.length} items`;
    }

    refresh() {
      this.page = 1;
      this.hideDefaultPagination();
      this.prepareNextItems();
    }

    async prepareNextItems() {
      let url = this.nextPageUrl(this.page);
      let items = await this.fetchItems(url);
      /* disable animations */
      items.forEach((el) => el.removeAttribute('data-cc-animate'));
      this.items = items;
      this.page++;
      this.complete();
    }

    async loadMore() {
      this.loading();
      this.insertItems(this.items);
      await this.prepareNextItems();
      this.complete();
    }

    get container() {
      return document.querySelector('main ' + this.insertSelector);
    }

    insertItems(items) {
      this.container.append(...items);
      this.handleImages();

      const event = new CustomEvent('nbd:collection:loaded-more', {
        detail: {
          action: 'loaded',
          count: this.items.length,
        },
      });

      window.dispatchEvent(event);
    }

    hideDefaultPagination() {
      document.querySelectorAll('main ' + this.paginationSelector).forEach((el) => (el.style.display = 'none'));
    }

    nextPageUrl(current_page) {
      let params = new URLSearchParams(window.location.search);
      let page = current_page || params.get('page') || 1;
      params.set('page', page + 1);
      let sectionId = this.container?.closest('[data-section-id]')?.getAttribute('data-section-id');
      if (sectionId) {
        params.set('section_id', sectionId);
      }
      return window.location.pathname + '?' + params.toString();
    }

    async fetchItems(url) {
      let res = await fetch(url);
      let text = await res.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, 'text/html');
      return html.querySelectorAll(`${this.insertSelector} ${this.itemSelector}`);
    }
  }

  function initCustomElement() {
    !window.customElements.get('nbd-load-more') && window.customElements.define('nbd-load-more', NBDLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomElement);
  } else {
    initCustomElement();
  }

  window.addEventListener('shopify:section:load', initCustomElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbd-product-specifications"] && !Shopify.designMode) return;
  try {
    
  class NBDTab extends HTMLElement {
    constructor() {
      super();
      this.label = this.getAttribute('label') || 'Tab';
    }
  }

  customElements.define('nbd-tab', NBDTab);

  class NBDTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('nbd-tab'));
      this.activeTabIndex = 0;
      this.render();
    }

    render() {
      const tabLabels = this.tabs.map((tab, index) => {
        return `<button type="button" class="nbd-tab-label ${index === this.activeTabIndex ? 'active' : ''}" data-index="${index}">${tab.label}</button>`;
      }).join('');

      const tabContents = this.tabs.map((tab, index) => {
        return `<div class="nbd-tab-content ${index === this.activeTabIndex ? 'active' : 'hidden'}">${tab.innerHTML}</div>`;
      }).join('');

      this.innerHTML = `
        <div class="nbd-tab-labels">
          ${tabLabels}
        </div>
        <div class="nbd-tab-contents">
          ${tabContents}
        </div>
      `;

      this.querySelectorAll('.nbd-tab-label').forEach(button => {
        button.addEventListener('click', (event) => {
          this.activeTabIndex = parseInt(event.target.getAttribute('data-index'));
          this.render();
        });
      });
    }
  }

  customElements.define('nbd-tabs', NBDTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
